module.exports = __webpack_public_path__ + "c3f3676b34317a10b0f5536ddde0f28c.MP3";